module.exports = __webpack_public_path__ + "img/valoresBack.8b6d2d04.jpg";